  //========================instagram_left
  var sldier = new Swiper(".instagram_left", {
    slidesPerView: 6.5,
    spaceBetween: 24,
    loop: true,
    allowTouchMove: false,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    speed: 3000,
    breakpoints: {
      320: {
        slidesPerView: 1.5,
        spaceBetween: 16,
        centeredSlides: true,
      },
      576: {
        slidesPerView: 3,
        spaceBetween: 16,
        centeredSlides: true,
      },
      768: {
        slidesPerView: 4.2,
        spaceBetween: 16,
        centeredSlides: true,
      },
      992: {
        slidesPerView: 5,
        spaceBetween: 24,
        centeredSlides: false,
      },
      1200: {
        slidesPerView: 5.5,
        spaceBetween: 24,
        centeredSlides: false,
      },
      1441: {
        slidesPerView: 6.5,
        spaceBetween: 24,
        centeredSlides: false,
      },
    },
  });

  //=========================instagram_right
  var sldier2 = new Swiper(".instagram_right", {
    spaceBetween: 24,
    slidesPerView: 6.5,
    loop: true,
    allowTouchMove: false,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
      reverseDirection: true,
    },
    speed: 3000,
    breakpoints: {
      320: {
        slidesPerView: 1.5,
        spaceBetween: 16,
        centeredSlides: true,
      },
      576: {
        slidesPerView: 3,
        spaceBetween: 16,
        centeredSlides: true,
      },
      768: {
        slidesPerView: 4.2,
        spaceBetween: 16,
        centeredSlides: true,
      },
      992: {
        slidesPerView: 5,
        spaceBetween: 24,
        centeredSlides: false,
      },
      1200: {
        slidesPerView: 5.5,
        spaceBetween: 24,
        centeredSlides: false,
      },
      1441: {
        slidesPerView: 6.5,
        spaceBetween: 24,
        centeredSlides: false,
      },
    },
  });

  document
    .querySelector(".instagram_left")
    .addEventListener("mouseenter", function () {
      clearTimeout(sldier.autoplay.timeout); // Cancel any existing timeout
      sldier.autoplay.stop(); // Force stop autoplay
    });

  document
    .querySelector(".instagram_left")
    .addEventListener("mouseleave", function () {
      sldier.autoplay.start(); // Start autoplay when mouse leaves
    });

  document
    .querySelector(".instagram_right")
    .addEventListener("mouseenter", function () {
      clearTimeout(sldier2.autoplay.timeout); // Cancel any existing timeout
      sldier2.autoplay.stop(); // Force stop autoplay
    });

  document
    .querySelector(".instagram_right")
    .addEventListener("mouseleave", function () {
      sldier2.autoplay.start(); // Start autoplay when mouse leaves
    });
